export default {
  abuseUrl: 'https://example.com/api/v1/abuse/',
  getVideoUrl: (id) => { return `/api/v1/video/${id}/` }
}
